import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import { CustomTab } from '../../../components'
import { Box } from '@mui/material';

const AlertTab = () => {
  const navigate = useNavigate();

  return (
    <Box mt={-2}>
      <CustomTab
        panels={[
          {
            name: "Eventos",
            route: '/alertas/eventos',
            onChange: () => navigate('eventos'),
            content: <Outlet />
          },
          {
            name: "Alertas",
            route: '/alertas/configuracion',
            onChange: () => navigate('configuracion/transaccionales'),
            content: <Outlet />
          },
          {
            name: "Intermitencias",
            route: '/alertas/intermitencias',
            onChange: () => navigate('intermitencias'),
            content: <Outlet />
          },
        ]}
      />
    </Box>
  )
}

export default AlertTab